import React, {useState, useEffect, memo} from 'react'
import {Redirect} from 'react-router-dom'
import {ServerConfig} from 'config'
import axios from 'axios'
import {useSelector} from 'react-redux'

import loading_gif from '../../assets/img/loading.gif'

import Select from 'react-select';
import SortableTbl from "react-sort-search-table";
import NonPaginatedList from '../../components/EntryListAndEdit/NonPaginatedList'
import DatePicker from "react-datepicker";
import InfoBanner from 'components/common/InfoBanner'

import "react-datepicker/dist/react-datepicker.css";

import {makeStyles} from '@material-ui/core/styles'
import {Typography, Grid, Checkbox, Button} from '@material-ui/core'
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import AccessTimeIcon from "@material-ui/icons/AccessTimeOutlined"

const useStyles = makeStyles((theme) => ({}))

const DailySummaries = () => {
  const token = useSelector(state => state.auth.access_token)

  const tenant = useSelector(state => state.auth.tenant)
  console.log(tenant);
  console.log(tenant.state);

  const [availableMachines, setAvailableMachines] = useState([])
  const [selectedMachine_ids, setSelectedMachine_ids] = useState([])
  const [dailySummaries, setDailySummaries] = useState([])
  const [dailySummariesReceived, setDailySummariesReceived] = useState(new Date())

  let date_before_one_week = new Date();
  date_before_one_week.setDate(date_before_one_week.getDate() - 7);
  const [startDate, setStartDate] = useState(date_before_one_week);
  const [endDate, setEndDate] = useState(new Date());

  const materials_and_abbreviations = [
    ["aluminum", "Aluminum", "Alu"],
    ["scrap_aluminum", "Aluminum", "Sc(Alu)"],
    ["bi-metal", "Bi-Metal", "Bi-M"],
    ["scrap_bi-metal", "Bi-Metal", "Sc(Bi-Metal)"],
    ["pete", "PETE", "PETE"],
    ["scrap_pete", "PETE", "Sc(PETE)"],
    ["hdpe", "HDPE", "HDPE"],
    ["scrap_hdpe", "HDPE", "Sc(HDPE)"],
    ["ldpe", "LDPE", "LDPE"],
    ["scrap_ldpe", "LDPE", "Sc(LDPE)"],
    ["pp", "PP", "PP"],
    ["scrap_pp", "PP", "Sc(PP)"],
    ["ps", "PS", "PS"],
    ["scrap_ps", "PS", "Sc(PS)"],
    ["pvc", "PVC", "PVC"],
    ["scrap_pvc", "PVC", "Sc(PVC)"],
    ["other", "OTHER", "Other"],
    ["scrap_other", "OTHER", "Sc(Other)"],
    ["glass", "Glass", "Glass"],
    ["scrap_glass", "Glass", "Sc(Glass)"],
    ["bag-in-box", "Bag-in-Box", "BiB"],
    ["paperboard-carton", "Paperboard-Carton", "PC"],
    ["multilayer-pouch", "Multilayer-Pouch", "MP"],
  ]

  const [selectedMaterials, setSelectedMaterials] =  useState(materials_and_abbreviations.map(a => a[0])); //useState(['alu', 'pete', 'hdpe', 'glass']);

  let default_options;
  if (tenant.state == "CA") {
    default_options = ["show_scrap"];
  } else if (tenant.state == "NY") {
    default_options = [""];
  } else {
    default_options = [""];
  }

  const [selectedOptions, setSelectedOptions] = useState(default_options);

  const [cols, setCols] = useState([]);
  const [heads, setHeads] = useState([]);

  const [isLoading, setIsLoading] = useState(false);

  const classes = useStyles()

  async function fetchMachineList(token) {
    const config = {headers: {'Content-Type': 'application/json'}}

    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }

    const results = await axios.get(`${ServerConfig.SERVER_URL}/tenant/machines`, config);
    const options = [];

    for (let idx in results.data) {
      options.push(results.data[idx].id);
    }
    setAvailableMachines(options);
    setSelectedMachine_ids(options)
  }


  async function request_download(token) {
    setIsLoading(true);

    const config = {
      responseType: 'blob',
      headers: {
        'Content-Type': 'application/json',
        'Accept': "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      },
    }

    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }

    const machine_ids = [];
    for (let idx in selectedMachine_ids) {
      machine_ids.push(selectedMachine_ids[idx]);
    }

    // the date-selection are per day, so set startdate time to 00:00 and enddate time to 23:59
    const start = new Date(startDate);
    start.setHours(0, 0, 0, 0);

    const end = new Date(endDate);
    end.setHours(23, 59, 59, 999);

    const body = JSON.stringify({
      machine_ids: machine_ids,
      start_ts_utc: start.getTime(),
      end_ts_utc: end.getTime(),
      materials: selectedMaterials,
      show_scrap: selectedOptions.includes('show_scrap')
    })

    var filename;

    let ret = axios.post(`${ServerConfig.SERVER_URL}/tenant/daily_summaries_excel`, body, config)
      .then(response => {
        const disposition = response.headers['content-disposition'];
        filename = disposition.split(/;(.+)/)[1].split(/=(.+)/)[1];

        if (filename.toLowerCase().startsWith("utf-8''")) {
          filename = decodeURIComponent(filename.replace("utf-8''", ''));
        } else {
          filename = filename.replace(/['"]/g, '');
        }
        return response.data;
      })
      .then(response_data => {
        let blob = new Blob([response_data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'})
        var url = window.URL.createObjectURL(blob);
        var a = document.createElement('a');
        a.href = url;
        a.download = filename;
        document.body.appendChild(a); // append the element to the dom
        a.click();
        a.remove(); // afterwards, remove the element
      })
      .catch(error => {
        console.error(error);
      })
      .finally(() => {
        setIsLoading(false);
      });

    return ret;
  }


  async function request_download_pdf(token) {
    setIsLoading(true);

    const config = {
      responseType: 'blob',
      headers: {
        'Content-Type': 'application/json',
        'Accept': "application/pdf"
      },
    }

    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }

    const machine_ids = [];
    for (let idx in selectedMachine_ids) {
      machine_ids.push(selectedMachine_ids[idx]);
    }

    const start = new Date(startDate);
    start.setHours(0, 0, 0, 0);

    const end = new Date(endDate);
    end.setHours(23, 59, 59, 999);

    const body = JSON.stringify({
      machine_ids: machine_ids,
      start_ts_utc: start.getTime(),
      end_ts_utc: end.getTime()
    })

    var filename;

    axios.post(`${ServerConfig.SERVER_URL}/tenant/daily_summaries_pdf`, body, config)
      .then(response => {
        const disposition = response.headers['content-disposition'];
        filename = disposition.split(/;(.+)/)[1].split(/=(.+)/)[1];

        if (filename.toLowerCase().startsWith("utf-8''")) {
          filename = decodeURIComponent(filename.replace("utf-8''", ''));
        } else {
          filename = filename.replace(/['"]/g, '');
        }
        return response.data;
      })
      .then(response_data => {
        let blob = new Blob([response_data], {type: 'application/pdf'})
        var url = window.URL.createObjectURL(blob);
        var a = document.createElement('a');
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        a.remove();
      })
      .catch(error => {
        console.error(error);
      });

    setIsLoading(false);
  }


  useEffect(() => {
    fetchMachineList(token)
  }, [token])

  useEffect(() => {
    let new_cols = ["date"];
    let new_heads = ["Date"];

    //if (window.innerWidth >= 1080) {
      console.log("Selected options: "+selectedOptions);

      for (let i = 0; i < materials_and_abbreviations.length; i++) {

        if (selectedMaterials.includes(materials_and_abbreviations[i][0])) {
            if (materials_and_abbreviations[i][0].includes("scrap")) {
              if(selectedOptions.includes("show_scrap")) {
                new_cols.push(materials_and_abbreviations[i][1] + " weight scrap");
                new_heads.push(materials_and_abbreviations[i][2] + " lbs");
              }
            } else {
              new_cols.push(materials_and_abbreviations[i][1] + " weight");
              new_heads.push(materials_and_abbreviations[i][2] + " lbs");

              new_cols.push("cumulative_"+ materials_and_abbreviations[i][1] + " weight");
              new_heads.push("Cumm. "+ materials_and_abbreviations[i][2] + " lbs");
            }

            if (materials_and_abbreviations[i][0].includes("scrap")) {
              if(selectedOptions.includes("show_scrap")) {
                new_cols.push("scrap_value_paid_" + materials_and_abbreviations[i][1]);
                new_heads.push("Paid " + materials_and_abbreviations[i][2]);
              }
            } else {
              new_cols.push("refund_value_paid_" + materials_and_abbreviations[i][1]);
              new_heads.push("Paid " + materials_and_abbreviations[i][2]);

              new_cols.push("cumulative_refund_value_paid_"+ materials_and_abbreviations[i][1]);
              new_heads.push("Cumm. Paid "+ materials_and_abbreviations[i][2]);
            }
        }
      //}
    }

    //new_cols.push("total_paid");
    //new_heads.push("Paid Total");

    setCols(new_cols);
    setHeads(new_heads);
  }, [selectedMaterials, selectedOptions])

  if (!token) {
    return <Redirect to="/login"/>
  }

  const handleChange = (event) => {
      if (event.target.checked) {
        if (event.target.name == 'all_materials'){
            setSelectedMaterials(materials_and_abbreviations.map(a => a[0]));
        }else{
            if (!selectedMaterials.includes(event.target.value)) {
              setSelectedMaterials([...selectedMaterials, event.target.name]);
            }
        }
      } else {
        if (event.target.name == 'all_materials'){
            setSelectedMaterials([]);
        }else{
            const newSelectedMaterials = selectedMaterials.filter((entry) => entry !== event.target.name);
            setSelectedMaterials(newSelectedMaterials);
        }
      }
    };

  const handleChangeFields = (event) => {
    console.log(event);
    if (event.target.checked) {
      if (!selectedOptions.includes(event.target.name)) {
        setSelectedOptions([...selectedOptions, event.target.name]);
      }
    } else {
      const newSelectedOptions = selectedOptions.filter((entry) => entry !== event.target.name);
      setSelectedOptions(newSelectedOptions);
    }
  }

  let date_before_1_week = new Date();
  date_before_1_week.setDate(new Date().getDate() - 7);
  date_before_1_week.setHours(0,0,0,1);

  let date_today = new Date();
  date_today.setHours(23,59,59,0);

  return (
    <>
      <Grid container spacing={3}>
        <InfoBanner
          items={[
            <>Material weight (lbs) <b>does not include</b> scrap-weight</>,
            <>"Paid material" <b>only includes</b> paid CRV</>,
            <>Counts are transformed to weight using <b>Method 1</b> of the Calrecycle handbook</>,
          ]}
        />
        <Grid xs={3} md={2} style={{'marginBottom': '20px'}}>
          <Typography variant="h2">&nbsp;</Typography>
          <Typography variant="h2"><Checkbox checked={(selectedOptions.includes('show_scrap'))}
                                             onChange={handleChangeFields} name="show_scrap"/> Show scrap</Typography>
        </Grid>

        <Grid xs={3} md={2} style={{'marginBottom': '20px'}}>
          <Typography variant="h2">&nbsp;</Typography>
          <Typography variant="h2"><Checkbox checked={selectedMaterials.length === materials_and_abbreviations.length}
                                             onChange={handleChange} name="all_materials"/> All materials</Typography>
        </Grid>

        <Grid xs={12} style={{'textAlign': 'left'}}>
            <Grid xs={12} style={{'textAlign':'center'}}>
              <Typography variant="h2">
                Materials:
              </Typography>
            </Grid>

            <Grid container style={{'textAlign': 'left'}}>
              <Grid xs={2}><Typography variant="h2"><Checkbox checked={selectedMaterials.includes("aluminum")} onChange={handleChange} name="aluminum" /> Alu</Typography></Grid>
              <Grid xs={2}><Typography variant="h2"><Checkbox checked={selectedMaterials.includes("bi-metal")} onChange={handleChange} name="bi-metal" /> Bi-Metal</Typography></Grid>
              <Grid xs={2}><Typography variant="h2"><Checkbox checked={selectedMaterials.includes("pete")} onChange={handleChange} name="pete" /> PETE #1</Typography></Grid>
              <Grid xs={2}><Typography variant="h2"><Checkbox checked={selectedMaterials.includes("hdpe")} onChange={handleChange} name="hdpe" /> HDPE #2</Typography></Grid>
              <Grid xs={2}><Typography variant="h2"><Checkbox checked={selectedMaterials.includes("ldpe")} onChange={handleChange} name="ldpe" /> LDPE #4</Typography></Grid>
              <Grid xs={2}><Typography variant="h2"><Checkbox checked={selectedMaterials.includes("pp")} onChange={handleChange} name="pp" /> PP #5</Typography></Grid>
              <Grid xs={2}><Typography variant="h2"><Checkbox checked={selectedMaterials.includes("ps")} onChange={handleChange} name="ps" /> PS #6</Typography></Grid>
              <Grid xs={2}><Typography variant="h2"><Checkbox checked={selectedMaterials.includes("pvc")} onChange={handleChange} name="pvc" /> PVC #3</Typography></Grid>
              <Grid xs={2}><Typography variant="h2"><Checkbox checked={selectedMaterials.includes("other")} onChange={handleChange} name="other" /> Other #7</Typography></Grid>
              <Grid xs={2}><Typography variant="h2"><Checkbox checked={selectedMaterials.includes("glass")} onChange={handleChange} name="glass" /> Gl</Typography></Grid>
              <Grid xs={2}><Typography variant="h2"><Checkbox checked={selectedMaterials.includes("bag-in-box")} onChange={handleChange} name="bag-in-box" /> BiB</Typography></Grid>
              <Grid xs={2}><Typography variant="h2"><Checkbox checked={selectedMaterials.includes("paperboard-carton")} onChange={handleChange} name="paperboard-carton" /> PC</Typography></Grid>
              <Grid xs={2}><Typography variant="h2"><Checkbox checked={selectedMaterials.includes("multilayer-pouch")} onChange={handleChange} name="multilayer-pouch" /> MP</Typography></Grid>
            </Grid>
        </Grid>

        {(!isLoading && dailySummaries !== []) &&
          <>
            <Grid xs={12}>
              <Button onClick={() => {
              request_download(token);
              }} style={{'marginRight': '20px'}}>Download Excel</Button>
              <Button onClick={() => {
              request_download_pdf(token);
              }} style={{'marginRight': '20px'}}>Download PDF</Button>

            </Grid>
          </>
        }

        <Grid xs={12} style={{'marginTop': '10px', 'overflowX': 'auto'}}>
          {!isLoading &&
            <>
              <Grid item xs={12} style={{'padding': 0, marginTop: '20px', marginBottom:'20px6'}}>
                <Card style={{'margin': 0}}>
                  <CardContent style={{'paddingBottom': 0, 'paddingTop': 0}}>
                    <AccessTimeIcon style={{'color': 'rgb(0,79,113)'}}/> Data Received: {dailySummariesReceived.toString()}
                  </CardContent>
                </Card>
              </Grid>

              {availableMachines.length > 0 &&
                <NonPaginatedList
                  sortable_columns={true}
                  list_get_url={`${ServerConfig.SERVER_URL}/tenant/dailysummaries`}
                  //detail_get_url={`${ServerConfig.SERVER_URL}/tenant/machines/`}
                  //detail_put_url={`${ServerConfig.SERVER_URL}/tenant/machines/`}

                  column_names={cols}
                  header_names={heads}

                  optional_column_names={[]}
                  optional_header_names={[]}

                  filter_inputs={[
                    {
                      'name': 'machine_ids',
                      'type': 'device_ids',
                      'label': 'Devices:',
                      'initial_value': selectedMachine_ids,
                    },
                    {
                      'name': 'start_ts_utc',
                      'type': 'utc_date_start',
                      'label': 'Start-Date (incl.):',
                      'initial_value': date_before_1_week
                    },
                    {'name': 'end_ts_utc', 'type': 'utc_date_end', 'label': 'End-Date (incl.):', 'initial_value': date_today}
                  ]}

                  editable_fields={[]}
                  non_editable_fields={[]}
                  show_machine_stats={false}
                  show_scrap={selectedOptions.includes('show_scrap')}
                  onFilterChange={(filterValues) => {
                    if (filterValues.machine_ids) {
                      setSelectedMachine_ids(filterValues.machine_ids.value);
                    }
                    if (filterValues.start_ts_utc) {
                      setStartDate(new Date(filterValues.start_ts_utc.value));
                    }
                    if (filterValues.end_ts_utc) {
                      setEndDate(new Date(filterValues.end_ts_utc.value));
                    }
                  }}
                />
              }
            </>
          }
          {isLoading &&
              <img src={loading_gif} style={{'width': '150px'}}/>
          }
        </Grid>
      </Grid>
    </>
  )
}

export default DailySummaries

  
